export const selectSidebarIsOpen = (state) => state.appReducer.sidebar.sidebarIsOpen || false
export const selectOpenToEditTrade = (state) => state.appReducer.sidebar.toEditOpenTrade || ''
export const selectSidebarAssetName = (state) => state.appReducer.sidebar.sidebarAssetName || ''
export const selectSidebarType = (state) => state.appReducer.sidebar.sidebarType || ''
